// extracted by mini-css-extract-plugin
export default {"trade-count":"_3wrl_","tradeCount":"_3wrl_"};